import React from 'react';
import { IMAGES, bgStyle } from '@/config/images';

const TemplateRecommendations = () => {
  return (
    <div className="min-h-screen -m-4 lg:-m-6 p-4 lg:p-6" style={bgStyle(IMAGES.GCODE_CAM)}>
      <div className="fixed inset-0 bg-black/90 -z-10" style={{ pointerEvents: 'none' }} />
    <div className="space-y-6" data-testid="templates-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Tools / CNC Templates</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">CNC Template Recommendations</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            Suggestions for starting points and reusable setups for common CNC workflows (signs, cabinetry,
            surfacing, profile cuts, and more).
          </p>
        </div>
      </div>
      <div className="panel text-sm text-[var(--text-secondary)]">
        <p>
          This page will eventually list CNC-Helpdesk templates and recommended starting points. For now,
          it serves as a structural placeholder so that the navigation and site map are complete.
        </p>
      </div>
    </div>
    </div>
  );
};

export default TemplateRecommendations;
